import React, { useState } from "react";
import { Form, Input, theme } from "antd";
import { validateConfig } from "../../../../../config/validate.config";
import {
  informantOptions,
  relationOptions,
} from "../../../Options/historyOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import SelectWithOtherInput from "../../../../../blocks/FormItems/SelectWithOtherInput";
import { hexToRgba } from "../../../../../helpers/utility";

const Informant = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const { token } = theme.useToken(); 
  return (
    <>
      <DeselectableRadioGroup
        label={"Informant"}
        name={"informant"}
        form={form}
        options={informantOptions}
        setRefresh={setRefresh}
      />
      {form.getFieldValue("informant") === "relative" && (
        <div
          className="subsection-card informant-relative-fields"
          style={{
            borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
            background: "transparent",
            marginTop: "8px",
          }}
        >
          <SelectWithOtherInput
            name={"relation_with_patient"}
            label={"Relation With Patient"}
            options={relationOptions}
            form={form}
            selectWidth={200}
            inputWidth={180}
            selectProps={{
              onChange: () => {
                setRefresh((prev) => !prev);
              },
            }}
          />

          <Form.Item
            className="informant-name-item"
            name="informant_name"
            label="Name"
          >
            <Input type="text" maxLength={50} style={{ width: 200 }} />
          </Form.Item>
        </div>
      )}
    </>
  );
};

export default Informant;
